import { PaletteMode } from "@mui/material";
import { StateCreator } from "zustand";

export type AppColor = "teal" | "pink";

export interface GeneralSettingsSlice {
  generalSettings: {
    externalLinkNavigation: boolean;
    googleCalendar: boolean;
    primaryColor: AppColor;
    theme: PaletteMode;
    set: (setting: Omit<Partial<GeneralSettingsSlice["generalSettings"]>, "set">) => void;
  };
}

const createGeneralSettingsSlice: StateCreator<GeneralSettingsSlice, [], [], GeneralSettingsSlice> = (set) => ({
  generalSettings: {
    externalLinkNavigation: true,
    googleCalendar: true,
    primaryColor: "teal",
    theme: "dark",
    set: (setting) =>
      set((state) => ({
        generalSettings: { ...state.generalSettings, ...setting },
      })),
  },
});

export default createGeneralSettingsSlice;
